export enum EArticleType {
  GENERAL = "general",
  HIGHLIGHT = "highlight",
}

export enum EArticleCategories {
  PUBLIC = "Public",
  MEMBERS = "Members",
}
